/*
 *                     NOTICE
 *            COPYRIGHT 2024 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbstractOperandExpressionNodeConverter } from "abreact/expression/ui/editor/impl/model/impl/row/operandValue/converter/AbstractOperandExpressionNodeConverter";
// import WithoutNodeType = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractOperandValue.WithoutNodeType;
// import AbstractStandardOperandValue = GuidedExpressionEditor.AbstractModel.AbstractRowModel.AbstractStandardOperandValue;

export class AbstractStandardOperandExpressionNodeConverter extends AbstractOperandExpressionNodeConverter {
  getStateWithoutNodeType(expExpressionNode) {
    return {
      ...super.getStateWithoutNodeType(expExpressionNode),
      displayValue: expExpressionNode.displayValue
    };
  }
}
//# sourceMappingURL=AbstractStandardOperandExpressionNodeConverter.js.map
